<nav class="space-y-1 mb-2">
  @if (heading) {
    <p class="text-xs text-grey-900 mb-2">
      {{ heading }}
    </p>
  }
  <ng-content></ng-content>
</nav>
